import { render, staticRenderFns } from "./autoAskPrice.vue?vue&type=template&id=53c99ecd&scoped=true&"
import script from "./autoAskPrice.vue?vue&type=script&lang=js&"
export * from "./autoAskPrice.vue?vue&type=script&lang=js&"
import style0 from "./autoAskPrice.vue?vue&type=style&index=0&id=53c99ecd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c99ecd",
  null
  
)

export default component.exports